// components/ConfigModal/SelectBankModal.jsx
import React from "react";
import { Modal, Button } from "react-bootstrap";

const SelectBankModal = ({ show, bank, onClose, onConfirm }) => {
  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Confirmer la sélection</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {bank?.status ? (
          <p className="text-primary text-center fw-bold">
            Cette configuration est déjà sélectionnée.
          </p>
        ) : (
          <p className="text-dark text-center">
            Êtes-vous sûr de vouloir sélectionner la banque{" "}
            <strong>{bank?.name}</strong> comme configuration par défaut ?
          </p>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          Annuler
        </Button>
        {!bank?.status && (
          <Button variant="primary" onClick={onConfirm}>
            Confirmer
          </Button>
        )}
      </Modal.Footer>
    </Modal>
  );
};

export default SelectBankModal;
